export default {
  label: {
    original: 'Original: ',
  },
};
